<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="400px"
    >
      <v-card>
        <v-toolbar
          flat
          class="mb-4"
        >
            <v-toolbar-title>
                <span class="text-h5">{{ $t('contacts.importForm.title') }}</span>
            </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-alert class="text-justify">
            <span v-html="$t('contacts.importForm.notice')"/>
          </v-alert>
          <v-form
            ref="form"
            v-model="valid"
          >
            <v-file-input
              :label="$t('contacts.importForm.fileField')"
              accept="text/csv"
              prepend-icon="mdi-file-delimited"
              v-model="file"
            >
            </v-file-input>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="close()"
          >
            {{ $t('contacts.btn.cancel') }}
          </v-btn>
          <v-btn
            text
            color="primary"
            :disabled="!valid || !file"
            @click="submit()"
          >
            {{ $t('contacts.btn.import') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'contacts-import-dialog',
  data () {
    return {
      valid: false,
      file: null
    }
  },
  computed: {
    ...mapGetters({
      dialog: 'contacts/importForm/dialog'
    })
  },
  methods: {
    ...mapActions({
      closeDialog: 'contacts/importForm/close',
      import: 'contacts/import'
    }),

    async submit () {
      await this.import(this.file)
      await this.closeDialog()
    },

    close () {
      this.closeDialog()
    }
  }
}
</script>

<style>

</style>
